import React from "react";
import { useTranslation } from "react-i18next";
import WhatElseBox from "./WhatElseBox";

const WhatElse = ({ data }) => {
  const { t } = useTranslation();
  return (
    <section className="WhatElse">
      <div className="WhatElse__Heading">
        {t(
          "components.tabs.overview.components.WhatElse.heading",
          "What else you will get?"
        )}
      </div>
      <div className="WhatElse__Content">
        {data?.map((item, i) => (
          <WhatElseBox key={`sdt4dfg@35${i}`} data={item} />
        ))}
      </div>
    </section>
  );
};

export default React.memo(WhatElse);
